import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['button'];
  static values = { seconds: Number, label: String };

  connect() {
    if (this.secondsValue <= 0) return;

    this.remaining = this.secondsValue;
    this.startCooldown();

    this.intervalId = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    this.clearTimer();
  }

  // pointer-events alone leaves the button reachable by keyboard.
  guard(event) {
    if (this.intervalId) event.preventDefault();
  }

  tick() {
    this.remaining -= 1;

    if (!this.element.isConnected) return this.clearTimer();

    if (this.remaining > 0) return this.render();

    this.clearTimer();
    this.endCooldown();
  }

  startCooldown() {
    this.buttonTarget.classList.add('el-btn-cooldown');
    this.buttonTarget.setAttribute('aria-disabled', 'true');
    this.render();
  }

  endCooldown() {
    this.buttonTarget.classList.remove('el-btn-cooldown');
    this.buttonTarget.removeAttribute('aria-disabled');
    this.buttonTarget.textContent = this.labelValue;
  }

  render() {
    this.buttonTarget.textContent = `${this.labelValue} in ${this.remaining}s`;
  }

  clearTimer() {
    if (!this.intervalId) return;

    clearInterval(this.intervalId);
    this.intervalId = null;
  }
}
